import React, { useContext, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import { SprawneMiastoContext } from './SprawneMiastoContext';

export default function LoadingScreen(props: {
    loaded: boolean;
    setLoaded: (state: boolean) => void;
}) {
    const location = useLocation();

    const Context = useContext(SprawneMiastoContext);

    useEffect(() => {
        if (location.pathname === '/' && !props.loaded) {
            startLoading();
        }
    }, []);

    function loaded() {
        document.body.style.overflow = 'auto';
        props.setLoaded(true);
        Context?.setLoadingScreenVisible(false);
    }

    function startLoading() {
        document.body.style.overflow = 'hidden';
        Context?.setLoadingScreenVisible(true);
        props.setLoaded(false);
    }

    if (location.pathname !== '/') {
        return <></>;
    } else {
        return (
            <>
                {!props.loaded && (
                    <div
                        className={
                            'fixed inset-0 z-50 flex h-screen w-screen flex-col items-center justify-center overflow-hidden bg-SM-dark'
                        }>
                        <div className={'flex flex-col items-center'}>
                            <div className={'flex overflow-hidden'}>
                                <motion.h1
                                    animate={{
                                        y: ['100%', '0%'],
                                    }}
                                    transition={{
                                        duration: 1,
                                    }}
                                    className={
                                        'font-montserrat text-2xl font-medium uppercase tracking-[.06em] text-white sm:text-5xl'
                                    }>
                                    Sprawne&nbsp;
                                </motion.h1>

                                <motion.h1
                                    animate={{
                                        y: ['100%', '0%'],
                                    }}
                                    transition={{
                                        delay: 0.5,
                                        duration: 1,
                                    }}
                                    className={
                                        'font-montserrat text-2xl font-medium uppercase tracking-[.06em] text-white sm:text-5xl'
                                    }>
                                    Miasto
                                </motion.h1>
                            </div>

                            <motion.div
                                className={'h-1 w-1 rounded-xl bg-SM-yellow sm:mt-1'}
                                onAnimationComplete={loaded}
                                animate={{
                                    width: ['0%', '50%'],
                                }}
                                transition={{
                                    duration: 2,
                                }}
                            />
                        </div>
                    </div>
                )}
            </>
        );
    }
}
